import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import Icon from '../../baseComponents/gui/icon/Icon';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';

const Title = React.forwardRef(function Title({ title, titleData, titleIcon }, ref) {
  const { t } = useTranslation();

  return (
    <h2
      className={classNames('w-modal__title', {
        'w-modal__title_data': titleData,
      })}
    >
      {!titleData ? (
        safeHTML(t(title))
      ) : (
        <>
          {safeHTML(t(title))} <Icon name={titleData.src} className={'w-modal__title-icon'} />
          <span>+{titleData?.value}</span>
        </>
      )}
      {titleIcon && <img src={titleIcon} alt='title-icon' />}
    </h2>
  );
});
export default Title;
Title.propTypes = {};
